export enum EFormConfig {
  Insured = 1,
  Insurance = 2,
  Claim = 3,
  Object = 4,
  ObjectTariff = 5,
  Contacts = 6,
  InsuranceFinance = 7,
  Affiliates = 8,
  Agents = 9,
}
